import gql from 'graphql-tag'  //引入graphql
const apollo={
	tasks:gql`query tasks($cate: String!,$userId:String){
		tasks(cate:$cate,userId:$userId){
			name,
			id,
			assignTime,
			uri,
			process{
				id,
				name,
				uri,
				tags,
				entry,
				owner{
					id,
					name,
					account
				}
				app{
					name,
					system
				}
			}
		}
	}`,
	processes:gql`query processes($cate:String!,$userId:String,$page:Int,$size:Int){
		processes(cate:$cate,userId:$userId,page:$page,size:$size){
			total,
			processes{
				id,
			    name,
			    uri,
			    entry,
			    pendingTasks,
			    update,
			    app{
			    	name
			    }
			}
		}
	}`,
	faq:gql`query question($id: String, $start: Int, $limit: Int, $keyword: String, $status: Int, $recommStatus: Int, $quesLabel: String, $startLabel: String) {
		standardQuestions(id: $id, similar: true, start: $start, limit: $limit, keyword: $keyword, status: $status, recommStatus: $recommStatus, quesLabel: $quesLabel, startLabel:, $startLabel) {
		  totalCount
		  edges {
			node {
			  id
			  question
			  quesCode
			  quesLabel
			  quesDesc
			  createTime
			  updateTime
			  status
			  recommStatus
			  similarCount
			  recommCount
			  slots {
				id
				slotName
				slotAlias
				entityDeclId
				ask
				isMust
				__typename
			  }
			  answers {
				id
				answer
				condition
				__typename
			  }
			  similarQuestions {
				edges {
				  node {
					id
					similarQues
					stdQuesId
					createTime
					updateTime
					isLabel
					status
				  }
				}
			  }
			}
		  }
		}
	}`,
	guide:gql`query guide($first: Int,$offset: Int,$id: ID,$title: String,$stepTitle: String,$context: String,$keyword: String
	,$isRealease: Boolean,$state: Int,$appId: [String],$appTag: String,$appName: String,$appCode: [String]){
	    guide(first:$first,offset:$offset,id:$id,title:$title,stepTitle:$stepTitle,context:$context,keyword:$keyword
	,isRealease:$isRealease,state:$state,appId:$appId,appTag:$appTag,appName:$appName,appCode:$appCode){
	    totalCount
	    edges{
	      node{
	        id
	        title
	  		keyword
	  		mainpic
	  		isRealease
	 	 	createUser
	  		createUserAccount
	 	 	createTime
	  		updateTime
	  		updateUser
	  		updateUserAccount
	  		state
	  		guideStepList{
	          listId
	          context
	          guideId
	          stepNo
	          stepTitle
	          guideStepAppList{
	            listAppId
	            appId
	            appCode
	            appName
	            appTag
	            appUrl
	            guideId
	            guideStepId
	          }
	        }
	      }
	    }
	  }
	}`,
	//机器人信息
	 robotInfo: gql`query robotInfo($start:Int, $limit:Int,$keyword:String,$id: String, $tenantId: String,$status: String){
	  robotInfos(start:$start,limit:$limit,keyword:$keyword,id:$id,tenantId:$tenantId,status:$status){
		totalCount
		edges{
		  node{
			id
			name
			image
			welcomes
			voiceType
			status
			}
		  }
		}
	}`,
	//已登录，通过appcenter_url拿场景
    appProjects: gql`query appProjects {
        appProjects {
          id
          text
          released
          description
          snapshot
          background
          icon
          updated
          type
          sort
          paragraphs {
            apps {
              id
              text
              name
              sort
              code
              uri
              __typename
            }
            id
            title
            context
            sort
            subtitle
            __typename
          }
          __typename
        }
    }`,
    //未登录，通过appcenter_url拿场景
    anonymityAppProjects: gql`query anonymityAppProjects($tenant: String!) {
        anonymityAppProjects(tenant: $tenant) {
            id
            text
            description
            background
        }
    }`,
    appStat: gql`query appStatistics($filter: Map, $type: AppStatisticType!) {
        appStatistics(filter: $filter, type: $type) {
          code
          name
          value
        }
    }`,
    appAnonymityStat: gql`query anonymityAppStatistics($filter: Map, $type:AnonymityAppStatisticType!, $tenant:String!) {
        anonymityAppStatistics(filter: $filter, type: $type, tenant: $tenant) {
		  name
		  code
		  value
        }
    }`,
    //应用详情
    app: gql`query app($id:String!){
        app(id:$id){
              abbreviation
              code
              contact
              department
              description
              dynamicAttributes
              telephone
              icon
              id
              kind
              name
              recommend
              tags
              text
              uri
        }
    }`,

    appStatistics: gql`query appStatistics($filter: Map, $type: AppStatisticType!) {
        appStatistics(filter: $filter, type: $type) {
          code
          name
          value
          __typename
        }
    }`,


    me: gql` query me {
        me {
          id
          name
          username
          cardNo
          phone
          email
          openid
          positions {
            tags
            id
            index
            code
            startTime
            active
            endTime
            cardType
            cardNo
            description
            createTime
            source
            dataSource
            timestamp
            validStartTime
            validEndTime
            createSource
            createDataSource
            positionAttrsValues: attrsValues {
              key
              value
            }
            dept {
              id
              name
              code
              active
              revocation
              ancestor {
                name
                code
              }
            }
            post {
              id
              name
              code
              active
              postType
              ancestor {
                name
                code
              }
            }
          }
        }
  }`
}
export default apollo


// WEBPACK FOOTER //
// ./src/graphql/apollo.js